import { Component, OnInit,Input } from '@angular/core';
import {PrintService} from '../print.service';
import {Anatomies} from '../anatomy/anatomy';
import {Subscription} from 'rxjs';
import { FetalechoService } from '../fetalecho.service';

@Component({
    selector: 'app-systemprint',
    templateUrl: './systemprint.component.html',
    styleUrls: ['./systemprint.component.scss'],
    standalone: false
})
export class SystemprintComponent implements OnInit {
  @Input('System') System:string;
  @Input('name') Name:string;
  @Input('fetus') fetus:number;
  @Input('dir') dir:string;
  anatomies: Anatomies;
  show=false;
  sub:Subscription;
  alist;
  fetalMeas;
  ivsStatus;
  ivs;
  showIVS;
  Situs=['Situs', 'AVC', 'VAC', 'PVR', 'SVR', 'PE'];
  SitusItems =[];
  Atria=['Atria','LeftAtrium', 'RightAtrium', 'InteratrialSeptum', 'ForamenOvale', 'CoronarySinus'];
  AtriaItems =[];
  Ventricles=['Ventricles','LeftVentricle', 'RightVentricle', 'IVS', 'IVSStatus'];
  VentriclesItems =[];
  Valves=['Valves','AorticValve', 'PulmonaryValve', 'TricupsidValve', 'TricupsidValve','MitralValve' ];
  ValvesItems =[];
  Vessels=['Vessels','AorticArch', 'IsthmicFlow', 'PulmonaryArtery', 'DuctusArteriosus'];
  VesselsItems =[];
  comments:any;

  constructor(public print:PrintService, public fes:FetalechoService) { 
    this.anatomies = new Anatomies();
  }

  ngOnInit() {
    if(this.print.loaded){
      if(this.print[this.System] && this.print[this.System][this.fetus]){
        this.setList()
        this.show=true;
        this.comments = this.print[this.System][this.fetus].Comments
      }
    }
    else{
      this.sub = this.print.loadMsg.subscribe(()=>{
        this.sub.unsubscribe();
        if(this.print[this.System] && this.print[this.System][this.fetus]){
          this.setList();
          this.show=true;
        }
      });
    }
    
  }

  setList(){
    this.alist=[];
    for(let i=0;  i < this.anatomies[this.System].length; i++){
      if(this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']]>-1 && this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']] !== null){
        if(this.anatomies[this.System][i]['db'] == 'IVS'){
          this.ivs = {nm: this.anatomies[this.System][i]['db'], val:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']], type:this.getType(this.anatomies[this.System][i]['db']), com:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']+'Note']}
        }else if(this.anatomies[this.System][i]['db'] == 'IVSStatus'){
          this.ivsStatus = {nm: this.anatomies[this.System][i]['db'], val:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']], type:this.getType(this.anatomies[this.System][i]['db']), com:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']+'Note']};
        }
        else{
          this.alist.push({nm: this.anatomies[this.System][i]['db'], val:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']], type:this.getType(this.anatomies[this.System][i]['db']), com:this.print[this.System][this.fetus][this.anatomies[this.System][i]['db']+'Note']})
        }
      }
    }
    if(this.ivs || this.ivsStatus || this.print[this.System][this.fetus]['IVSNote']){
      this.showIVS = true;
      if(this.ivsStatus){
        this.ivsStatus.com = this.print[this.System][this.fetus]['IVSNote'];
      }
    }
    this.alist.forEach((i) => {
      if(i.type === 'Situs')
        this.SitusItems.push(i)
      if(i.type === 'Atria')
        this.AtriaItems.push(i)
      if(i.type === 'Ventricles')
        this.VentriclesItems.push(i)
      if(i.type === 'Valves')
        this.ValvesItems.push(i)
      if(i.type === 'Vessels')
        this.VesselsItems.push(i)
    })
    
  }

  getClass(item:any){
    if(item.nm === 'IVS' || item.nm === 'IVSStatus' || item.nm ==='Situs' || item.nm ==='PE'|| item.nm ==='AVC' || item.nm ==='VAC'|| item.nm ==='PVR'|| item.nm ==='SVR'){
      return 'op'
    } 
    return item.val == 0 ? 'seen': (item.val == 1 ? 'unseen':(this.System =='chestfetal' ? '':'comments'));
  }

  getType(item){
    if(this.Situs.includes(item))
      return 'Situs'
    if(this.Atria.includes(item))
      return 'Atria'
    if(this.Ventricles.includes(item))
      return 'Ventricles'
    if(this.Valves.includes(item))
      return 'Valves'
    if(this.Vessels.includes(item))
      return 'Vessels'
  }

  getAwnser(item){
    if(item.nm === 'VAC' || item.nm === 'AVC'){
      return item.val === 0 ? 'No': 'Yes';
    }
    if(item.nm === 'PVR' || item.nm === 'SVR'){
      return item.val === 0 ? 'Abnormal': (item.nm ==='PVR' ? 'toLeftAtrium' : 'toRightAtrium');
    }
    if(item.nm === 'Situs'){
      return item.val === 0 ? 'Solitus' : (item.val == 1 ? 'Ambigous':'Inversus')
    }
    if(item.nm ==='PE')
      return item.val === 0 ? 'Seen': 'Unseen';
    return item.val === 0 ? 'normal' : (item.val == 1 ? 'Unseen':'Abnormal')
  }
  getPVR(a){
    return `systems.${this.System}.${a.name}.return ${this.fes.fetalEchoForm.get('PVRStatus').value} systems.${this.System}.${a.name}.title `
  }

}
